var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "messages-filter" } },
    [
      _c(
        "f7-list",
        [
          _c(
            "f7-list-item",
            { class: _vm.additionalClass },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start no-gutter w-100" },
                [
                  _c("fieldset", { staticClass: "d-flex" }, [
                    _c("legend", { staticClass: "sr-only" }, [
                      _vm._v(_vm._s(_vm.$t("filter.actions"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group mr-2" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btnFilter",
                            attrs: {
                              "aria-label": _vm.$t("common.rfrsh"),
                              title: _vm.$t("common.rfrsh"),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("refreshInbox")
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-rotate-right fs-14px",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group mx-2" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btnFilter_2",
                            attrs: {
                              "aria-label": _vm.$t("common.extract_list"),
                              title: _vm.$t("common.extract_list"),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("extractCSV")
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-light fa-upload fs-14px",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "fab-label" }, [
                              _vm._v(_vm._s(_vm.$t("common.extract_list"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "fieldset",
                    { staticClass: "form-group mx-2" },
                    [
                      _c("legend", { staticClass: "sr-only" }, [
                        _vm._v(_vm._s(_vm.$t("filter.filter_by_direction"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-button-group",
                        {
                          staticClass: "mt-sm-0",
                          attrs: {
                            role: "group",
                            "aria-label": _vm.$t("filter.filter_by_direction"),
                          },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: _vm.role === 2 ? "primary" : "",
                                "aria-pressed":
                                  _vm.role === 2 ? "true" : "false",
                                "aria-label": _vm.$t("common.all"),
                              },
                              on: {
                                click: function ($event) {
                                  _vm.role = 2
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.all")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: _vm.role === 1 ? "primary" : "",
                                "aria-pressed":
                                  _vm.role === 1 ? "true" : "false",
                                "aria-label": _vm.$t("common.sent"),
                              },
                              on: {
                                click: function ($event) {
                                  _vm.role = 1
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.sent")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: _vm.role === 0 ? "primary" : "",
                                "aria-pressed":
                                  _vm.role === 0 ? "true" : "false",
                                "aria-label": _vm.$t("common.received"),
                              },
                              on: {
                                click: function ($event) {
                                  _vm.role = 0
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.received")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showListGroupPanel() && _vm.hasRight("rtp_group_create")
                    ? _c(
                        "b-col",
                        {
                          staticClass: "p-0",
                          attrs: { cols: "1", offset: "3" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              class:
                                _vm.modeFilter === 1
                                  ? "navbar-button-selected"
                                  : "navbar-button",
                              attrs: { variant: "primary", size: "sm" },
                              on: {
                                click: function ($event) {
                                  return _vm.applyFilter(1)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("filter.tab_unit")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showListGroupPanel() && _vm.hasRight("rtp_group_create")
                    ? _c(
                        "b-col",
                        { staticClass: "p-0", attrs: { cols: "1" } },
                        [
                          _c(
                            "b-button",
                            {
                              class:
                                _vm.modeFilter === 2
                                  ? "navbar-button-selected"
                                  : "navbar-button",
                              attrs: { variant: "primary", size: "sm" },
                              on: {
                                click: function ($event) {
                                  return _vm.applyFilter(2)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("filter.tab_group")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showButtonCreateVerify()
                    ? _c(
                        "b-col",
                        {
                          attrs: {
                            cols: "12",
                            sm: "5",
                            md: "4",
                            xl: "4",
                            offset: "0",
                          },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btnFilter_2 mt-3 mt-xl-0",
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("createVerify")
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa-light fa-plus fs-14px",
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "fab-label" }, [
                                _vm._v(_vm._s(_vm.$t("verifications.verify"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showButtonImportLot()
                    ? _c(
                        "b-col",
                        {
                          staticClass: "showLargeScreenOnly",
                          attrs: { cols: "2" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btnFilter",
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("refreshInbox")
                                },
                              },
                            },
                            [
                              _c("i", {
                                attrs: { f7: "fa-light fa-upload fs-14px" },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "fab-label" }, [
                                _vm._v(_vm._s(_vm.$t("common.imprt_list"))),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.displayFilter
                    ? _c("b-col", {
                        staticClass:
                          "d-flex flex-row-reverse showLargeScreenOnly mt-25px",
                        attrs: { cols: "5", offset: "7" },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "f7-list-item",
            {
              staticClass: "showLargeScreenOnly",
              class: {
                "filter-item-section": true,
                "d-none": !_vm.displayFilter,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "min-w-100" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex row justify-content-start",
                      attrs: { cols: "9" },
                    },
                    [
                      _vm.showFilterSupplierId() && _vm.LMSGsupplierconfig
                        ? _c("div", { staticClass: "filter-item col-4 mb-5" }, [
                            _c(
                              "label",
                              {
                                staticClass: "filter-item-title",
                                attrs: { for: "filterSupplierId" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("filter.supplier_id")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "filter-item-content" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterSupplierId,
                                    expression: "filterSupplierId",
                                  },
                                ],
                                class: {
                                  "filter-item-input": true,
                                  "filter-item-input-complete":
                                    _vm.filterSupplierId,
                                },
                                attrs: {
                                  id: "filterSupplierId",
                                  type: "text",
                                  placeholder: _vm.$t("filter.supplier_id"),
                                },
                                domProps: { value: _vm.filterSupplierId },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.filterSupplierId = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterSupplierSIREN()
                        ? _c("div", { staticClass: "filter-item col-4 mb-5" }, [
                            _c(
                              "label",
                              {
                                staticClass: "filter-item-title",
                                attrs: { for: "filterSiren" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("common.srn")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "filter-item-content" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterSiren,
                                    expression: "filterSiren",
                                  },
                                ],
                                class: {
                                  "filter-item-input": true,
                                  "filter-item-input-complete": _vm.filterSiren,
                                },
                                attrs: {
                                  id: "filterSiren",
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "common.srn_placeholder_supplier"
                                  ),
                                },
                                domProps: { value: _vm.filterSiren },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.filterSiren = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterSupplierName()
                        ? _c("div", { staticClass: "filter-item col-4 mb-5" }, [
                            _c(
                              "label",
                              {
                                staticClass: "filter-item-title",
                                attrs: { for: "filterSupplierName" },
                              },
                              [_vm._v(_vm._s(_vm.$t("common.social_reason")))]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "filter-item-content" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.filterSupplierName,
                                    expression: "filterSupplierName",
                                  },
                                ],
                                class: {
                                  "filter-item-input": true,
                                  "filter-item-input-complete":
                                    _vm.filterSupplierName,
                                },
                                attrs: {
                                  id: "filterSupplierName",
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "filter.social_reason_placeholder"
                                  ),
                                },
                                domProps: { value: _vm.filterSupplierName },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.filterSupplierName = $event.target.value
                                  },
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterDoctype()
                        ? _c("div", { staticClass: "filter-item col-4 mb-5" }, [
                            _c(
                              "label",
                              {
                                staticClass: "filter-item-title",
                                attrs: { for: "filterDocumentType" },
                              },
                              [_vm._v(_vm._s("Type du document"))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "filter-item-content d-flex" },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.filterDocumentType,
                                        expression: "filterDocumentType",
                                      },
                                    ],
                                    ref: "selectDoctype",
                                    staticClass: "cursor fs-14px h-auto z-2",
                                    attrs: { id: "filterDocumentType" },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.filterDocumentType = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "IDCARD" } },
                                      [_vm._v("Carte d'identité")]
                                    ),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "RIB" } }, [
                                      _vm._v("RIB"),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "Kbis" } }, [
                                      _vm._v("Kbis"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "fa-light fa-chevron-down cursor ml--20px z-1",
                                  attrs: { size: "17px", id: "status-chevron" },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterReason()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    for: "filterReason",
                                    title: _vm.$t("filter.reason"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("filter.reason")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.reason,
                                        expression: "reason",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete": _vm.reason,
                                    },
                                    attrs: {
                                      id: "filterReason",
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "filter.reason_placeholder"
                                      ),
                                    },
                                    domProps: { value: _vm.reason },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.reason = $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterStatus() && _vm.serviceId === "1"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title:
                                      _vm.serviceId === _vm.services.SUPPLIERS
                                        ? _vm.$t("common.kyc_status")
                                        : _vm.$t("common.status.status_label"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.serviceId === _vm.services.SUPPLIERS
                                          ? _vm.$t("common.kyc_status")
                                          : _vm.$t("common.status.status_label")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "filter-item-content d-flex justify-content-between p-1 pt-2",
                                  attrs: {
                                    id:
                                      "status-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    href: "#",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class:
                                        "fixed-span-size " +
                                        (_vm.statusDisplay.nb > 0
                                          ? "filter-item-input-complete"
                                          : ""),
                                    },
                                    [_vm._v(_vm._s(_vm.statusDisplay.label))]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa-light fa-chevron-down",
                                    attrs: {
                                      size: "17px",
                                      id: "status-chevron",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target:
                                      "status-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    title: _vm.$t(
                                      "filter.selected_status_none"
                                    ),
                                    triggers: "focus",
                                    placement: "bottom",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "DealPrudencecolorBlack",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("filter.standard_title")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.statusList,
                                        function (status, index) {
                                          return _c(
                                            "span",
                                            {
                                              key:
                                                _vm.$t(
                                                  "common.status.rtp." +
                                                    status.id
                                                ) +
                                                "-" +
                                                index,
                                            },
                                            [
                                              _vm.showStatus(status) &&
                                              _vm.arrayStatusListStandard.includes(
                                                status.id
                                              )
                                                ? _c(
                                                    "b-form-checkbox",
                                                    {
                                                      attrs: {
                                                        value: 1,
                                                        "unchecked-value": 0,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return _vm.delayApplyFilter(
                                                            _vm.modeFilter
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: status.state,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            status,
                                                            "state",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "status.state",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-normal fs-13px",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "common.status.rtp." +
                                                                  status.id
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("hr", {
                                    staticClass: "my-1 margin-hr-status",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "DealPrudencecolorBlack",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("filter.rejection_title")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.statusList,
                                        function (status, index) {
                                          return _c(
                                            "span",
                                            {
                                              key:
                                                _vm.$t(
                                                  "common.status.rtp." +
                                                    status.id
                                                ) +
                                                "-" +
                                                index,
                                            },
                                            [
                                              _vm.showStatus(status) &&
                                              _vm.arrayStatusListRejection.includes(
                                                status.id
                                              )
                                                ? _c(
                                                    "b-form-checkbox",
                                                    {
                                                      attrs: {
                                                        value: 1,
                                                        "unchecked-value": 0,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return _vm.delayApplyFilter(
                                                            _vm.modeFilter
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: status.state,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            status,
                                                            "state",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "status.state",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-normal fs-13px",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "common.status.rtp." +
                                                                  status.id
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("hr", {
                                    staticClass: "my-1 margin-hr-status",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "DealPrudencecolorBlack",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("filter.recall_title")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.statusList,
                                        function (status, index) {
                                          return _c(
                                            "span",
                                            {
                                              key:
                                                _vm.$t(
                                                  "common.status.rtp." +
                                                    status.id
                                                ) +
                                                "-" +
                                                index,
                                            },
                                            [
                                              _vm.showStatus(status) &&
                                              _vm.arrayStatusListRecall.includes(
                                                status.id
                                              )
                                                ? _c(
                                                    "b-form-checkbox",
                                                    {
                                                      attrs: {
                                                        value: 1,
                                                        "unchecked-value": 0,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return _vm.delayApplyFilter(
                                                            _vm.modeFilter
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: status.state,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            status,
                                                            "state",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "status.state",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-normal fs-13px",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "common.status.rtp." +
                                                                  status.id
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("hr", {
                                    staticClass: "my-1 margin-hr-status",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "DealPrudencecolorBlack",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("filter.payment_title")
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.statusList,
                                        function (status, index) {
                                          return _c(
                                            "span",
                                            {
                                              key:
                                                _vm.$t(
                                                  "common.status.rtp." +
                                                    status.id
                                                ) +
                                                "-" +
                                                index,
                                            },
                                            [
                                              _vm.showStatus(status) &&
                                              _vm.arrayStatusListPayment.includes(
                                                status.id
                                              )
                                                ? _c(
                                                    "b-form-checkbox",
                                                    {
                                                      attrs: {
                                                        value: 1,
                                                        "unchecked-value": 0,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return _vm.delayApplyFilter(
                                                            _vm.modeFilter
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: status.state,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            status,
                                                            "state",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "status.state",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-normal fs-13px",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "common.status.rtp." +
                                                                  status.id
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterStatus() && _vm.serviceId !== "1"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title:
                                      _vm.serviceId === _vm.services.SUPPLIERS
                                        ? _vm.$t("common.kyc_status")
                                        : _vm.$t("common.status.status_label"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.serviceId === _vm.services.SUPPLIERS
                                          ? _vm.$t("common.kyc_status")
                                          : _vm.$t("common.status.status_label")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "filter-item-content d-flex justify-content-between p-1 pt-2",
                                  attrs: {
                                    id:
                                      "status-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    href: "#",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        "filter-item-input-complete":
                                          _vm.statusDisplay.nb > 0,
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.statusDisplay.label))]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa-light fa-chevron-down",
                                    attrs: {
                                      size: "17px",
                                      id: "status-chevron",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target:
                                      "status-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    title: _vm.$t(
                                      "filter.selected_status_none"
                                    ),
                                    triggers: "focus",
                                    placement: "bottomright",
                                  },
                                },
                                _vm._l(
                                  _vm.statusList,
                                  function (status, index) {
                                    return _c(
                                      "span",
                                      { key: status.name + "-" + index },
                                      [
                                        _vm.showStatus(status)
                                          ? _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: {
                                                  value: 1,
                                                  "unchecked-value": 0,
                                                },
                                                model: {
                                                  value: status.state,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      status,
                                                      "state",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "status.state",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(_vm._s(status.label)),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterStatusKYC()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "filter-item-title ml-2px text-ellipsis",
                                  attrs: {
                                    for: "filterStatusKYC",
                                    title:
                                      _vm.serviceId === _vm.services.SUPPLIERS
                                        ? _vm.$t("common.kyc_status")
                                        : _vm.$t("common.status.status_label"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.serviceId === _vm.services.SUPPLIERS
                                          ? _vm.$t("common.kyc_status")
                                          : _vm.$t("common.status.status_label")
                                      ) +
                                      "\n              "
                                  ),
                                  _c("span", { staticClass: "color-red" }, [
                                    _vm._v("* "),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content d-flex" },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.status,
                                          expression: "status",
                                        },
                                      ],
                                      staticClass:
                                        "cursor fs-13px h-auto z-2 color-grey-span-filterKYC",
                                      attrs: { id: "filterStatusKYC" },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.status = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("acceptance.select_stat")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.statusKYC, function (status) {
                                        return _c(
                                          "option",
                                          {
                                            key: status.code,
                                            domProps: { value: status.code },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(status.label) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      }),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass:
                                      "fa-light fa-chevron-down cursor ml--20px z-1",
                                    attrs: {
                                      size: "17px",
                                      id: "status-chevron",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterStatusVerif()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "filter-item-title ml-2px text-ellipsis",
                                  attrs: {
                                    for: "filterStatusVerif",
                                    title:
                                      _vm.serviceId === _vm.services.SUPPLIERS
                                        ? _vm.$t("common.kyc_status")
                                        : _vm.$t("common.status.status_label"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.serviceId === _vm.services.SUPPLIERS
                                          ? _vm.$t("common.kyc_status")
                                          : _vm.$t("common.status.status_label")
                                      ) +
                                      "\n              "
                                  ),
                                  _c("span", { staticClass: "color-red" }, [
                                    _vm._v("* "),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content d-flex" },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.status,
                                          expression: "status",
                                        },
                                      ],
                                      staticClass:
                                        "cursor fs-13px h-auto z-2 color-grey-span-filterKYC",
                                      attrs: { id: "filterStatusVerif" },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.status = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("acceptance.select_stat")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.statusVerif,
                                        function (status) {
                                          return _c(
                                            "option",
                                            {
                                              key: status.code,
                                              domProps: { value: status.code },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(status.label) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass:
                                      "fa-light fa-chevron-down cursor ml--20px z-1",
                                    attrs: {
                                      size: "17px",
                                      id: "status-chevron",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterContactName()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    for: "filterContactName",
                                    title: _vm.$t("filter.cntct_name"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("filter.cntct_name")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.cdtrOrDbtrNm,
                                        expression: "cdtrOrDbtrNm",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete":
                                        _vm.cdtrOrDbtrNm,
                                    },
                                    attrs: {
                                      id: "filterContactName",
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "filter.cntct_name_placeholder"
                                      ),
                                    },
                                    domProps: { value: _vm.cdtrOrDbtrNm },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.cdtrOrDbtrNm = $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterDebtorId()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    for: "filterDebtorId",
                                    title: _vm.$t("common.debtor_ibn"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.debtor_ibn")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.debtorId,
                                        expression: "debtorId",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete":
                                        _vm.debtorId,
                                    },
                                    attrs: {
                                      id: "filterDebtorId",
                                      type: "text",
                                      placeholder: _vm.$t("common.debtor_ibn"),
                                    },
                                    domProps: { value: _vm.debtorId },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.debtorId = $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterDebtorIdProvider()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    for: "filterDebtorIdProvider",
                                    title: _vm.$t(
                                      "requestToPay.provider_dbtor"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("requestToPay.provider_dbtor")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.debtorIdProvider,
                                        expression: "debtorIdProvider",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete":
                                        _vm.debtorIdProvider,
                                    },
                                    attrs: {
                                      id: "filterDebtorIdProvider",
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "requestToPay.provider_dbtor"
                                      ),
                                    },
                                    domProps: { value: _vm.debtorIdProvider },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.debtorIdProvider =
                                            $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterCreditorIdProvider()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    for: "filterCreditorIdProvider",
                                    title: _vm.$t(
                                      "requestToPay.provider_crdtr"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("requestToPay.provider_crdtr")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.creditorIdProvider,
                                        expression: "creditorIdProvider",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete":
                                        _vm.creditorIdProvider,
                                    },
                                    attrs: {
                                      id: "filterCreditorIdProvider",
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "requestToPay.provider_crdtr"
                                      ),
                                    },
                                    domProps: { value: _vm.creditorIdProvider },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.creditorIdProvider =
                                            $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterMsgId()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    for: "filterMsgId",
                                    title: _vm.$t("filter.msgId"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("filter.msgId")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.msgId,
                                        expression: "msgId",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete": _vm.msgId,
                                    },
                                    attrs: {
                                      id: "filterMsgId",
                                      type: "text",
                                      placeholder: _vm.$t("filter.msgId"),
                                    },
                                    domProps: { value: _vm.msgId },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.msgId = $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterTypeAction()
                        ? _c("div", { staticClass: "filter-item mb-5" }, [
                            _c(
                              "label",
                              {
                                staticClass: "filter-item-title",
                                attrs: { for: "filterTypeAction" },
                              },
                              [_vm._v(_vm._s(_vm.$t("filter.action_type")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "filter-item-content d-flex" },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.typeAction,
                                        expression: "typeAction",
                                      },
                                    ],
                                    ref: "selectTypeAction",
                                    staticClass: "cursor fs-14px h-auto z-2",
                                    attrs: { id: "filterTypeAction" },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.typeAction = $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("filter.action_type_choose")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "CREATE" } },
                                      [_vm._v(_vm._s(_vm.$t("history.CREATE")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "DELETE" } },
                                      [_vm._v(_vm._s(_vm.$t("history.DELETE")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "MODIFY" } },
                                      [_vm._v(_vm._s(_vm.$t("history.MODIFY")))]
                                    ),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "SEND" } }, [
                                      _vm._v(_vm._s(_vm.$t("history.SEND"))),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "CANCEL" } },
                                      [_vm._v(_vm._s(_vm.$t("history.CANCEL")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "ACCEPT" } },
                                      [_vm._v(_vm._s(_vm.$t("history.ACCEPT")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "REFUSE" } },
                                      [_vm._v(_vm._s(_vm.$t("history.REFUSE")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "MODIFY_AND_ACCEPT" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("history.MODIFY_AND_ACCEPT")
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "ACCEPT_AND_PAY" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("history.ACCEPT_AND_PAY")
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "PAY" } }, [
                                      _vm._v(_vm._s(_vm.$t("history.PAY"))),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "SAVE" } }, [
                                      _vm._v(_vm._s(_vm.$t("history.SAVE"))),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "UPLOAD" } },
                                      [_vm._v(_vm._s(_vm.$t("history.UPLOAD")))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "UPLOAD_API" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("history.UPLOAD_API"))
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "fa-light fa-chevron_down cursor ml--20px z-1",
                                  attrs: { size: "17px", id: "status-chevron" },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterEndToEndId()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    for: "filterEndToEndId",
                                    title: _vm.$t("common.invc_ref"),
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.invc_ref")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.endToEndId,
                                        expression: "endToEndId",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete":
                                        _vm.endToEndId,
                                    },
                                    attrs: {
                                      id: "filterEndToEndId",
                                      type: "text",
                                      placeholder: "End To End Id",
                                    },
                                    domProps: { value: _vm.endToEndId },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.endToEndId = $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterUser()
                        ? _c("div", { staticClass: "filter-item mb-5" }, [
                            _c(
                              "label",
                              {
                                staticClass: "filter-item-title",
                                attrs: { for: "filterUser" },
                              },
                              [_vm._v(_vm._s("Utilisateur"))]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "filter-item-content" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.user,
                                    expression: "user",
                                  },
                                ],
                                class: {
                                  "filter-item-input": true,
                                  "filter-item-input-complete": _vm.user,
                                },
                                attrs: {
                                  id: "filterUser",
                                  type: "text",
                                  placeholder: "Saisir l'identifiant",
                                },
                                domProps: { value: _vm.user },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.user = $event.target.value
                                    },
                                    function ($event) {
                                      return _vm.delayApplyFilter(
                                        _vm.modeFilter
                                      )
                                    },
                                  ],
                                },
                              }),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "filter-item col-4 mb-5" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "filter-item-title text-ellipsis",
                              attrs: {
                                title: _vm.$t("common.date_start_label"),
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("common.date_start_label")) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("datetime-picker-custom", {
                            staticClass: "z-1",
                            class: {
                              "filter-item-input": true,
                              "filter-item-input-complete": _vm.dateBegin,
                            },
                            attrs: {
                              format: "DD/MM/YYYY H:i:s",
                              customInputParentClass: "filter-item-content",
                              customInputClass: "w-100",
                              maxLength: 19,
                              placeholderValue: _vm.$t(
                                "common.datetime_picker_empty_date"
                              ),
                              inputIcon: "fa-solid fa-calendar",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.delayApplyFilter(_vm.modeFilter)
                              },
                            },
                            model: {
                              value: _vm.dateBegin,
                              callback: function ($$v) {
                                _vm.dateBegin = $$v
                              },
                              expression: "dateBegin",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "filter-item col-4 mb-5" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "filter-item-title text-ellipsis",
                              attrs: { title: _vm.$t("common.date_end_label") },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("common.date_end_label")) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("datetime-picker-custom", {
                            staticClass: "z-1",
                            class: {
                              "filter-item-input": true,
                              "filter-item-input-complete": _vm.dateEnd,
                            },
                            attrs: {
                              format: "DD/MM/YYYY H:i:s",
                              customInputParentClass: "filter-item-content",
                              customInputClass: "w-100",
                              maxLength: 19,
                              placeholderValue: _vm.$t(
                                "common.datetime_picker_empty_date"
                              ),
                              inputIcon: "fa-solid fa-calendar",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.delayApplyFilter(_vm.modeFilter)
                              },
                            },
                            model: {
                              value: _vm.dateEnd,
                              callback: function ($$v) {
                                _vm.dateEnd = $$v
                              },
                              expression: "dateEnd",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showFilterClearing()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: { title: _vm.$t("filter.clearing") },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("filter.clearing")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "filter-item-content d-flex justify-content-between p-1 pt-2",
                                  attrs: {
                                    id:
                                      "clearingType-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    href: "#",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class:
                                        "fixed-span-size " +
                                        (_vm.clearingDisplay.nb > 0
                                          ? "filter-item-input-complete"
                                          : ""),
                                    },
                                    [_vm._v(_vm._s(_vm.clearingDisplay.label))]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa-light fa-chevron-down",
                                    attrs: {
                                      size: "17px",
                                      id: "clearingType-chevron",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target:
                                      "clearingType-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    title: _vm.$t(
                                      "filter.selected_clearing_type_none"
                                    ),
                                    triggers: "focus",
                                    placement: "bottom",
                                  },
                                },
                                _vm._l(
                                  _vm.clearingList,
                                  function (clearing, index) {
                                    return _c(
                                      "span",
                                      {
                                        key:
                                          _vm.$t(
                                            "filter.orphan.clearing." +
                                              clearing.id
                                          ) +
                                          "-" +
                                          index,
                                      },
                                      [
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            attrs: {
                                              value: 1,
                                              "unchecked-value": 0,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.delayApplyFilter(
                                                  _vm.modeFilter
                                                )
                                              },
                                            },
                                            model: {
                                              value: clearing.state,
                                              callback: function ($$v) {
                                                _vm.$set(clearing, "state", $$v)
                                              },
                                              expression: "clearing.state",
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "filter.orphan.clearing." +
                                                      clearing.id
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterMsgType()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title: _vm.$t("common.routing.message"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("common.routing.message")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "filter-item-content d-flex justify-content-between p-1 pt-2",
                                  attrs: {
                                    id:
                                      "msgType-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    href: "#",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class:
                                        "fixed-span-size " +
                                        (_vm.messageTypeDisplay.nb > 0
                                          ? "filter-item-input-complete"
                                          : ""),
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.messageTypeDisplay.label)
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa-light fa-chevron-down",
                                    attrs: {
                                      size: "17px",
                                      id: "msgType-chevron",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target:
                                      "msgType-picker-link" +
                                      "-" +
                                      _vm.filterType +
                                      "-" +
                                      _vm.randomString,
                                    title: _vm.$t(
                                      "filter.selected_msg_type_none"
                                    ),
                                    triggers: "focus",
                                    placement: "bottom",
                                  },
                                },
                                _vm._l(_vm.msgTypeList, function (type, index) {
                                  return _c(
                                    "span",
                                    {
                                      key:
                                        _vm.$t(
                                          "filter.orphan.message_type." +
                                            type.id
                                        ) +
                                        "-" +
                                        index,
                                    },
                                    [
                                      _c(
                                        "b-form-checkbox",
                                        {
                                          attrs: {
                                            value: 1,
                                            "unchecked-value": 0,
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.delayApplyFilter(
                                                _vm.modeFilter
                                              )
                                            },
                                          },
                                          model: {
                                            value: type.state,
                                            callback: function ($$v) {
                                              _vm.$set(type, "state", $$v)
                                            },
                                            expression: "type.state",
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "filter.orphan.message_type." +
                                                    type.id
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                0
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterInitParty()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: { title: _vm.$t("orphan.init_party") },
                                },
                                [_vm._v(_vm._s(_vm.$t("orphan.init_party")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.initParty,
                                        expression: "initParty",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete": _vm.msgId,
                                    },
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t("orphan.init_party"),
                                    },
                                    domProps: { value: _vm.initParty },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.initParty = $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showFilterMsgIdOrphan()
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "filter-item col-4 mb-5 text-truncate",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "filter-item-title text-ellipsis",
                                  attrs: {
                                    title: _vm.$t("orphan.msg_identifier"),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("orphan.msg_identifier"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "filter-item-content" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.msgId,
                                        expression: "msgId",
                                      },
                                    ],
                                    class: {
                                      "filter-item-input": true,
                                      "filter-item-input-complete": _vm.msgId,
                                    },
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "orphan.msg_identifier"
                                      ),
                                    },
                                    domProps: { value: _vm.msgId },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.msgId = $event.target.value
                                        },
                                        function ($event) {
                                          return _vm.delayApplyFilter(
                                            _vm.modeFilter
                                          )
                                        },
                                      ],
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex flex-row-reverse",
                      class: _vm.modeFilter === 3 ? "mt-5" : "mt-4",
                      attrs: { cols: "4" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm" },
                          on: {
                            click: function ($event) {
                              return _vm.applyFilter(_vm.modeFilter)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("filter.fltr")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2 d-inline d-xl-none",
                          attrs: { size: "sm", disabled: !_vm.hasInputFilter },
                          on: { click: _vm.clearFilterFields },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("creation_forms.clear_label")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2 d-none d-xl-inline",
                          attrs: { size: "sm", disabled: !_vm.hasInputFilter },
                          on: { click: _vm.clearFilterFields },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("filter.clr_fltr_field")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }